import * as utils from './../libs/user-agent'

// ユーザーエージェント判定
utils.uaDevice(true)
utils.uaOs(true)
utils.uaBrowser(true)
